module.exports = __webpack_public_path__ + "img/up-to-25-discount-img.95d291b1.png";